import { Injectable } from '@angular/core';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class PermissionService {
    private _currentUser: User | null = null;

    constructor(private _userService: UserService) {
        // Subscribe to user changes
        this._userService.user$.subscribe((user) => {
            console.log('PermissionService: User updated:', user);
            this._currentUser = user;
        });
    }

    /**
     * Check if user has specific permission
     * @param permission Permission string to check
     */
    hasPermission(permission: string): boolean {
        console.log(`PermissionService: Checking permission '${permission}' for user:`, this._currentUser);
        
        if (!this._currentUser) {
            console.warn('PermissionService: No current user found!');
            return false;
        }

        if (!this._currentUser.permissions) {
             console.warn('PermissionService: User has no permissions array!');
        }
        
        if (this._currentUser.roles && (this._currentUser.roles.includes('ADMIN') || this._currentUser.roles.includes('SUPERADMIN'))) {
            console.log('PermissionService: Granted via ADMIN/SUPERADMIN role bypass');
            return true;
        }

        const exactMatch = this._currentUser.permissions && this._currentUser.permissions.includes(permission);
        console.log(`PermissionService: Exact match for '${permission}':`, exactMatch);
        return exactMatch || false;
    }

    /**
     * Check if user has ANY of the provided permissions
     * @param permissions Array of permissions
     */
    hasAnyPermission(permissions: string[]): boolean {
        if (!this._currentUser) {
            return false;
        }

        if (this._currentUser.roles && (this._currentUser.roles.includes('ADMIN') || this._currentUser.roles.includes('SUPERADMIN'))) {
            return true;
        }

        if (!this._currentUser.permissions) {
            return false;
        }

        return permissions.some(p => this._currentUser!.permissions!.includes(p));
    }

    /**
     * Check if user has specific role
     * @param role Role string to check
     */
    hasRole(role: string): boolean {
        if (!this._currentUser || !this._currentUser.roles) {
            return false;
        }

        return this._currentUser.roles.includes(role);
    }
}
